import React from 'react';
import { EVENT_STATUS_VALUES, PAGES } from '../../../constants';
import BookingContextMenu from '../BookingContextMenu';
import EventsContextMenu from '../EventsContextMenu';

const EventsRow = ({
  event, eventDate, eventTime, leagues, bookUnbook,
  changePage,
}) => (
  <>
    <td>{event?.matchId}</td>
    <td>
      {eventDate}
      <span className="m-l-10">{eventTime}</span>
    </td>
    <td className="status" />
    <td>{event.teamHome.name}</td>
    <td>
      <span>{event.teamHome.score}</span>
      <span> - </span>
      <span>{event.teamAway.score}</span>
    </td>
    <td>{event.teamAway.name}</td>
    <td>{leagues.find((l) => l.id === event.leagueId).name}</td>
    <td>{event.season}</td>
    <td>{event.round}</td>
    <td>
      <div className="context-menu">
        <div className="context-menu__list">
          {event.status === EVENT_STATUS_VALUES.FUTURE
            ? (
              <BookingContextMenu
                bookUnbook={bookUnbook.bind(this, event)}
                bookedFlag={event.bookedFlag}
              />
            )
            : (event.status === EVENT_STATUS_VALUES.IN_PROGRESS
                            || event.status === EVENT_STATUS_VALUES.ENDED)
              ? (
                <EventsContextMenu
                  bookedFlag={event.bookedFlag}
                  changePage={changePage.bind(this, event)}
                  matchId={event.matchId}
                  oddsHistoryPage={PAGES.ODDS_HISTORY_STEP_1}
                  matchTimelinePage={PAGES.MATCH_TIMELINE}
                />
              ) : null}
        </div>
        <div className="context-menu__mask" />
      </div>
    </td>
  </>
);

export default EventsRow;
